<template>
  <div class="bg-white h-full rounded-lg shadow border border-gray-300 ">
    <div>
      <div :class="[resource.userId === profile.id ? 'bg-primary-500' : 'bg-yellow-500']" class="flex flex-row justify-between align-middle items-center rounded-t-lg  text-white h-full">
        <div class="flex justify-start align-middle items-center ml-3 h-8" />
        <div class="mr-3">
          <d-tooltip v-if="resource.userId == profile.id || hasRole('System Administrator')" label="See who this is shared with" class="mr-2">
            <d-icon v-if="resource.userId == profile.id || hasRole('System Administrator')" class="text-white cursor-pointer text-md" icon="users" @click="launchSharedWithSideDrawer(resource)" />
          </d-tooltip>
          <d-tooltip label="Copy link to this resource" class="mr-2">
            <d-icon class="text-white cursor-pointer text-md" icon="clipboard" @click="copyResourceLink(resource)" />
          </d-tooltip>
          <d-icon v-if="resource.userId == profile.id || hasRole('System Administrator')" class="text-white cursor-pointer text-md mr-2" icon="edit" @click="launchResourcesModal(resource)" />
          <d-icon v-if="resource.userId == profile.id || hasRole('System Administrator')" class="text-white cursor-pointer text-md mr-2" icon="trash" @click="deleteResource(resource)" />
        </div>
      </div>
    </div>
    <div class="flex py-3 items-center ">
      <div class="flex-none">
        <a :href="`/resources/${resource.id}`" target="_blank"><d-icon class="text-secondary-600 p-5 text-3xl cursor-pointer" :icon="resource.fileIcon" /></a>
      </div>
      <div>
        <p class="font-bold text-sm">
          <d-tooltip v-if="truncatedTitle" :label="resource.name" multilined position="bottom">
            {{ truncateTitle(resource.name, 85) }}
          </d-tooltip>
          <span v-else>{{ truncateTitle(resource.name, 85) }}</span>
        </p>
        <p class="text-sm">
          Uploaded by: <a target="_blank" :href="'/profile/'+resource.userId">{{ resource.uploadedBy }}</a>
        </p>
        <p class="text-sm">
          Uploaded on: {{ resource.uploadedOn | formatShortDate }}
        </p>
        <div class="text=md">
          <a class="mr-2" :href="`/resources/${resource.id}`" target="_blank">
            {{ resource.type === 'File' ? 'Download' : 'Go To Link' }}</a>
          |<a class="ml-2" href="javascript:void(0)" @click="launchDescriptionModal(resource)">View Details
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex';
  import ResourceModal from './ResourceModal.vue';
  import ResourcesSharedWithSideDrawer from './ResourceSharedWithSideDrawer.vue';
  import ResourceDescriptionModal from './ResourceDescriptionModal.vue';

  export default {
    parent: true,
    props: {
      resource: {
        type: Object,
        default: () => {},
      },
    },

    data() {
      return {
        truncatedTitle: false,
        showDetails: false,
      };
    },

    computed: {
      ...mapGetters('d2Auth', ['profile', 'hasRole']),
    },

    methods: {
      copyResourceLink(resource) {
        const dummy = document.createElement('textarea');
        document.body.appendChild(dummy);
        let url = `${window.location.protocol}//${window.location.hostname}/resources/${resource.id}`;
        if (window.location.port) {
          url = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/resources/${resource.id}`;
        }
        dummy.value = url;
        dummy.select();
        document.execCommand('copy');
        document.body.removeChild(dummy);
        this.$toast.success('Resource URL copied!');
      },
      launchResourcesModal() {
        this.$modal.open({
          parent: this,
          component: ResourceModal,
          width: 600,
          hasModalCard: true,
          props: {
            resource: this.resource,
            userId: this.profile.id,
          },
          events: {
            handleUpdate: () => this.handleUpdate(),
          },
        });
      },
      launchDescriptionModal(resource) {
        this.$modal.open({
          parent: this,
          component: ResourceDescriptionModal,
          width: 600,
          hasModalCard: true,
          props: {
            resource,
          },
        });
      },
      launchSharedWithSideDrawer(resource) {
        this.$sideDrawer.open({
          parent: this,
          component: ResourcesSharedWithSideDrawer,
          props: {
            resource,
          },
        });
      },
      async deleteResource() {
        this.$dialog.confirm({
          title: 'Deleting Resource',
          message: `Are you sure you want to <b>delete</b> ${this.resource.name}? This action cannot be undone.`,
          confirmText: 'Delete Resource',
          confirmColor: 'red-500',
          onConfirm: async () => {
            await axios.delete(`/api/resources/${this.resource.id}`);
            this.$emit('update');
            this.$toast.success('Resource deleted!');
          },
        });
      },
      async handleUpdate() {
        this.$emit('update');
      },

      truncateTitle(str, num) {
        if (str.length <= num) {
          return str;
        }
        this.truncatedTitle = true;
        return `${str.slice(0, num)}...`;
      },
    },
  };
</script>